import { AppDownloadPage } from './AppDownloadPage';

export default AppDownloadPage;
